import { DiagnosticServiceModel } from './diagnostic.service.model';
import { DiagnosticServiceGroupType, DiagnosticServiceViewType } from '../enums';
import { DiagnosticServiceGroupModel } from './diagnostic-service-group.model';

export class DiagnosticServiceViewModel {
    type: DiagnosticServiceViewType;
    children: DiagnosticServiceGroupModel[];
    diagnosticServices: DiagnosticServiceModel[];
}
